import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomeView from "./components/HomeView";
import PlatformPage from "./components/PlatformPage";
import IndustryPage from "./components/IndustryPage";
import ResourcePage from "./components/ResourcePage";
import Pricing from "./components/Pricing";
import About from "./components/About";
import Contact from "./components/Contact";
import LegalPage from "./components/LegalPage";

import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="bg-[#05050A] text-white min-h-screen font-body flex flex-col justify-between">
      <BrowserRouter>
        <Header />
        
        {/* Main Content Body */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomeView />} />
            
            {/* Platform Subpages */}
            <Route path="/platform/risk" element={
              <PlatformPage 
                pageKey="risk" 
                tag="Risk Scoring" 
                title="Vendor Risk Intelligence" 
                desc="Generate dynamic composite scorecards (0-100) aggregating financial, cyber, performance, and compliance metrics. Instantly receive trigger alerts when vendor metrics drop below key SLA thresholds." 
              />
            } />
            <Route path="/platform/performance" element={
              <PlatformPage 
                pageKey="performance" 
                tag="Performance Scorecards" 
                title="Vendor Performance Analytics" 
                desc="Combine delivery consistency, response times, product quality audits, and price competitiveness into automated recurring scorecards for continuous reviews." 
              />
            } />
            <Route path="/platform/spend" element={
              <PlatformPage 
                pageKey="spend" 
                tag="Spend Optimization" 
                title="Spend Analytics & Cost Intelligence" 
                desc="Detect maverick spend, eliminate expensive software subscription overlaps, and surface contract consolidation leverage automatically." 
              />
            } />
            <Route path="/platform/compliance" element={
              <PlatformPage 
                pageKey="compliance" 
                tag="Compliance Auditing" 
                title="Compliance & Audit Automation" 
                desc="Automate document expiration tracking, insurance filings, regulatory updates, and SOC2 audit proof compliance seamlessly." 
              />
            } />
            <Route path="/platform/onboarding" element={
              <PlatformPage 
                pageKey="onboarding" 
                tag="Vendor KYC" 
                title="Vendor Onboarding & KYC" 
                desc="Simplify guided vendor intake profiles, integrate immediate background checks, and automate registration with instant AML screening." 
              />
            } />
            <Route path="/platform/contract" element={
              <PlatformPage 
                pageKey="contract" 
                tag="Contract Lifecycle" 
                title="Contract Lifecycle Management" 
                desc="Track renewals, flags key clauses automatically, extract liability levels, and secure contract validation alerts." 
              />
            } />

            {/* Industry Subpages */}
            <Route path="/industries/manufacturing" element={
              <IndustryPage 
                pageKey="manufacturing" 
                name="Manufacturing Solutions" 
                desc="Defend dense manufacturing logistics, secure continuous parts delivery SLAs, and track raw material cost indexes automatically." 
              />
            } />
            <Route path="/industries/retail" element={
              <IndustryPage 
                pageKey="retail" 
                name="Retail & E-commerce" 
                desc="Track omnichannel distribution fulfillment, manage vendor margins, and audit vendor shipping compliance." 
              />
            } />
            <Route path="/industries/healthcare" element={
              <IndustryPage 
                pageKey="healthcare" 
                name="Healthcare & Pharma" 
                desc="Enforce rigid regulatory SOC2 and HIPAA requirements across global medical suppliers and pharmaceutical providers." 
              />
            } />
            <Route path="/industries/bfsi" element={
              <IndustryPage 
                pageKey="bfsi" 
                name="BFSI Sector Auditing" 
                desc="Maintain premium financial institution vendor risk reviews, secure SOC2 validation profiles, and automate KYC/AML protocols." 
              />
            } />
            <Route path="/industries/it" element={
              <IndustryPage 
                pageKey="it" 
                name="IT & Tech Platforms" 
                desc="Uncover SaaS licenses overlap, monitor platform service downtime, and safeguard external cybersecurity risk indexes." 
              />
            } />
            <Route path="/industries/logistics" element={
              <IndustryPage 
                pageKey="logistics" 
                name="Logistics & Supply Chain" 
                desc="Track shipping SLA responses, compare fuel indexes, and streamline carrier performance analytics." 
              />
            } />

            {/* Resource Subpages */}
            <Route path="/resources/blog" element={<ResourcePage pageKey="blog" />} />
            <Route path="/resources/whitepapers" element={<ResourcePage pageKey="whitepapers" />} />
            <Route path="/resources/roi" element={<ResourcePage pageKey="roi" />} />
            <Route path="/resources/docs" element={<ResourcePage pageKey="blog" />} />
            <Route path="/resources/webinars" element={<ResourcePage pageKey="blog" />} />

            {/* Core pages */}
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* Legal pages */}
            <Route path="/legal/privacy" element={<LegalPage pageKey="privacy" />} />
            <Route path="/legal/terms" element={<LegalPage pageKey="terms" />} />

            {/* Fallback route */}
            <Route path="*" element={<HomeView />} />
          </Routes>
        </main>

        <Footer />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;